'use strict';

const Mn = require('backbone.marionette');
const NotificationModel = require('notify/domain/entity/notification');
const NotificationItemViewTemplate = require('notify/ui/template/item.hbs');

/**
 * 通知 Item View
 *
 * params.useMarkAsRead を true にすると、
 * markAsRead が表示されるようになる
 */
const NotificationItemView = Mn.View.extend({
    model: NotificationModel,
    tagName: 'li',
    className: 'notification-list-item list-item',
    template: NotificationItemViewTemplate,
    events: {
        'click .mark-as-read': 'read',
        'click .mark-as-unread': 'unread',
        'click .list-item-content': function() {
            if(this.model.isEditable() && this.onRead) {
                this.onRead();
            }
        }
    },
    modelEvents: {
        'change': 'render'
    },
    templateContext: function() {
        return {
            isRead: this.getOption('read'),
            isEditable: this.model.isEditable()
        }
    },

    initialize: function(params) {
        this._useMarkAsRead = params ? params.useMarkAsRead : false;
    },

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
        this.$('.parent-resource-icon').on('click', function(){
            location.hash = $(this).attr('data-url');
            return false;
        });

        if(this._useMarkAsRead && !this.model.get('read')) {
            this.$el.addClass('notification-unread');
        } else {
            this.$el.removeClass('notification-unread');
        }

        this.$('[data-toggle="tooltip"]').tooltip();
    },

    isNewArrival: function() {
        return false;
    },

    serializeData: function() {
        const version = this.model.get('version');
        if (version === 2 || version === 3) {
            return {
                title: this.model.getTitle(),
                subTitle: this.model.getSubTitle(),
                iconClass: this.model.getIconClass(),
                imageURL: this.model.getImageURL(),
                sender: this.model.getSender(),
                content: this.model.getContent(),
                link: this.model.getLinkURL(),
                eventAt: this.model.getEventAt(),
                isNewArrival: this.isNewArrival()
            };
        }

        let j = this.model.toJSON();
        j.detail = this.model.getDetailMessages();
        j.imageURL = this.model.getImageURL();
        j.title = this.model.getResource().data.name;
        j.isNewArrival = this.isNewArrival();
        j.eventAt = this.model.getEventAt();

        // 通知データのリンク先を取得
        if (!j.resource.deleted) {
            j.link = this.model.getLinkURL();
            const path = j.link.indexOf('#') > 0 ? j.link.substr(0, j.link.indexOf('#')) : j.link;
            j.isDifferentPageLink = path != location.pathname;
        }

        if(!j.read && this._useMarkAsRead) {
            j.showMarkAsRead = true;
        }

        return j;
    },

    read: function() {
        this.trigger('read');
        if(this.onRead) {
            this.onRead();
        }
        return false;
    },

    unread: function() {
        this.trigger('unread');
        if(this.onUnread) {
            this.onUnread();
        }
        return false;
    },
});

module.exports = NotificationItemView;



// WEBPACK FOOTER //
// ./notify/ui/view/item.js